import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove initial HTML loading shell (must not be inline script — CSP script-src 'self' in production)
window.addEventListener('load', () => {
  setTimeout(() => {
    const loadingElement = document.getElementById('initial-loading');
    if (!loadingElement) return;
    loadingElement.style.opacity = '0';
    loadingElement.style.transition = 'opacity 0.5s ease';
    setTimeout(() => loadingElement.remove(), 500);
  }, 1000);
});